import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { DateTime } from 'luxon'

import { useDefaultLayoutProps } from '../../layouts/DefaultLayout/useProps'
import { selectors } from '../../redux'

import { ClosedTemplateProps } from './index'

export const useClosedTemplateProps = (): ClosedTemplateProps => {
  const { t } = useTranslation()
  const getEventBySlug = useSelector(selectors.app.getEventBySlug)
  const currentLocale = useSelector(selectors.app.currentLocale)
  const layoutProps = useDefaultLayoutProps()

  return useMemo(() => {
    const date = getEventBySlug.data?.registration_closing_at
      ? DateTime.fromISO(getEventBySlug.data.registration_closing_at.replace(' ', 'T'))
          .setZone('Europe/Paris')
          .setLocale(currentLocale)
          .toLocaleString(DateTime.DATE_FULL)
      : undefined

    return {
      layout: layoutProps,
      text: t('closed.text', {
        event: getEventBySlug.data?.name,
        date: date,
      }),
      text2: t('closed.thank'),
    }
  }, [
    getEventBySlug.data?.name,
    getEventBySlug.data?.registration_closing_at,
    currentLocale,
    layoutProps,
    t,
  ])
}
